import { createLoginActions$, LoginActionEvent } from '@lseg-ciam/auth/login';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Subscription } from 'rxjs';
import { rigSharedStyles } from './heimdall-rig-styles.js';

@customElement('heimdall-rig-login-actions')
export class HeimdallRigLoginActions extends LitElement {
  @state()
  _subscription: Subscription | null = null;

  @state()
  _isSubscribed = false;

  @state()
  _lane: string | undefined;

  @state()
  _events: LoginActionEvent[] = [];

  onLaneChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    this._lane = target.value || undefined;
    this.clearSubscription();
  }

  onSetLane(lane?: string) {
    this._lane = lane;
    this.clearSubscription();
  }

  onSubscriptionRequestChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    const { checked } = target;

    if (!checked) {
      this._isSubscribed = false;
      this._events = [];
      return this._subscription?.unsubscribe();
    }

    this._isSubscribed = true;
    this._subscription = new Subscription();

    const loginActionsStream$ = createLoginActions$(this._lane);

    this._subscription.add(
      loginActionsStream$.subscribe({
        next: (event) => {
          this._events = [...this._events, event];
        },
      })
    );
  }

  clearSubscription() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
      this._isSubscribed = false;
      this._events = [];
    }
  }

  onClearEvents() {
    this._events = [];
  }

  formatTimestamp(at: number): string {
    const date = new Date(at);
    return date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }

  render() {
    return html`
      <div class="app">
        <h1>Login Actions${this._lane ? ` (${this._lane})` : ''}</h1>
        <ul>
          <li>
            <label>Lane</label>
            <input
              type="text"
              @change=${this.onLaneChanged}
              .value=${this._lane || ''}
              placeholder="lane or empty for 'base'"
            />
            <button @click=${() => this.onSetLane('AAAA')}>AAAA</button>
            <button @click=${() => this.onSetLane('BBBB')}>BBBB</button>
            <button @click=${() => this.onSetLane(undefined)}>Clear</button>
          </li>
          <li>
            <label>
              <input
                type="checkbox"
                @change=${this.onSubscriptionRequestChanged}
                .checked=${this._isSubscribed}
              />
              Subscribe to login actions stream
            </label>
          </li>
          <li>
            <button @click=${this.onClearEvents}>Clear events</button>
            <span>${this._events.length} events</span>
          </li>
        </ul>
        ${this._events.length > 0
          ? html`
              <pre>
${this._events
                  .map(
                    (event, idx) =>
                      `${idx + 1}. ${this.formatTimestamp(event.at)} [${
                        event.level || 'info'
                      }] ${event.action}`
                  )
                  .join('\n')}</pre
              >
            `
          : html`<p>No events</p>`}
      </div>
    `;
  }

  static styles = rigSharedStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-rig-login-actions': HeimdallRigLoginActions;
  }
}
